import axios from 'axios';

export default (token = false) => {
     
    
    return axios.create({
        baseURL: `${process.env.REACT_APP_API_BASE_URL}/archon/v1/`,
        headers: {
             'content-type': 'application/json',
             
            'authorization': `Bearer ${token}`
        }
    })
}